export default __webpack_public_path__ + "static/media/1.84d1cc52.jpg";